import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * AstroMarkdown — themed markdown renderer for AI astrology output.
 * Color codes: headings = gold, bold = gold, list bullets = purple, code = gold,
 * blockquote = soft purple stripe, tables = thin gold borders.
 */
export default function AstroMarkdown({ children }) {
  return (
    <div className="astro-markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ node, ...p }) => <h3 className="am-h" style={{ fontSize: "1.05rem" }} {...p} />,
          h2: ({ node, ...p }) => <h3 className="am-h" {...p} />,
          h3: ({ node, ...p }) => <h4 className="am-h" {...p} />,
          h4: ({ node, ...p }) => <h5 className="am-h" {...p} />,
          p:  ({ node, ...p }) => <p className="am-p" {...p} />,
          strong: ({ node, ...p }) => <strong className="am-bold" {...p} />,
          em: ({ node, ...p }) => <em className="am-italic" {...p} />,
          ul: ({ node, ...p }) => <ul className="am-ul" {...p} />,
          ol: ({ node, ...p }) => <ol className="am-ol" {...p} />,
          li: ({ node, ...p }) => <li className="am-li" {...p} />,
          blockquote: ({ node, ...p }) => <blockquote className="am-quote" {...p} />,
          code: ({ inline, ...p }) =>
            inline ? <code className="am-code-inline" {...p} /> : <code className="am-code" {...p} />,
          a: ({ node, ...p }) => <a className="am-link" target="_blank" rel="noreferrer" {...p} />,
          table: ({ node, ...p }) => <div className="am-table-wrap"><table className="am-table" {...p} /></div>,
          th: ({ node, ...p }) => <th className="am-th" {...p} />,
          td: ({ node, ...p }) => <td className="am-td" {...p} />,
          hr: () => <hr className="am-hr" />,
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
